/**
 * ComfyUI 诊断工具
 * 在浏览器控制台中运行诊断，帮助快速定位问题
 */

import { cudaApiBase } from '@/utils/cudaOnLine'

const ComfyUIDiagnosis = {
  // 检查 ComfyUI 服务器连接
  async checkServers() {
    console.log('🔍 开始检查 ComfyUI 服务器...\n')
    const servers = [
      'https://u680646-erl9-dd9fb7e3.westd.seetacloud.com:8443',
      'https://uu680646-erl9-dd9fb7e3.westd.seetacloud.com:8443'
    ]

    for (let i = 0; i < servers.length; i++) {
      const url = servers[i]
      try {
        console.log(`测试服务器 ${i + 1}: ${url}`)
        const response = await fetch(`${url}/system_stats`, {
          method: 'GET',
          timeout: 5000
        })

        if (response.ok) {
          const data = await response.json()
          console.log(`✅ 服务器 ${i + 1} 连接正常`)
          console.log('系统状态:', data)
        } else {
          console.error(`⚠️ 服务器 ${i + 1} 返回错误: ${response.status} ${response.statusText}`)
        }
      } catch (error) {
        console.error(`❌ 服务器 ${i + 1} 连接失败:`, error.message)
      }
      console.log('---\n')
    }
  },

  // 检查 CUDA 状态服务
  async checkCudaService() {
    console.log('🔍 检查 CUDA 状态服务...\n')
    try {
      const response = await fetch(cudaApiBase + '/cudaStatus', {
        method: 'GET',
        timeout: 5000
      })

      if (response.ok) {
        const data = await response.json()
        console.log('✅ CUDA 状态服务连接正常')
        console.log('CUDA 状态:', data)

        // 分析 CUDA 状态
        let availableCount = 0
        for (const key in data) {
          if (data[key].status === 'leisure') {
            availableCount++
          }
        }
        console.log(`\n📊 分析结果: ${availableCount} 个 CUDA 设备可用`)
      } else {
        console.error(`⚠️ CUDA 服务返回错误: ${response.status}`)
      }
    } catch (error) {
      console.error('❌ CUDA 状态服务连接失败:', error.message)
      console.log('可能原因:')
      console.log('1. 外部 CUDA 状态管理服务离线 (8.155.53.4:6084)')
      console.log('2. 网络无法访问该 IP')
      console.log('3. 防火墙阻止了请求')
    }
  },

  // 完整诊断
  async runFullDiagnosis() {
    console.clear()
    console.log('🚀 ComfyUI 完整诊断工具')
    console.log('='.repeat(50))
    console.log()

    // 1. 检查网络连接
    console.log('📡 第一步: 检查本地网络连接')
    if (window.navigator.onLine) {
      console.log('✅ 本地网络正常')
    } else {
      console.error('❌ 本地网络离线!')
      return
    }
    console.log()

    // 2. 检查 ComfyUI 服务器
    console.log('📡 第二步: 检查 ComfyUI 服务器')
    await this.checkServers()

    // 3. 检查 CUDA 服务
    console.log('📡 第三步: 检查 CUDA 状态服务')
    await this.checkCudaService()

    // 总结
    console.log('='.repeat(50))
    console.log('\n📋 诊断完成')
    console.log('\n💡 建议:')
    console.log('1. 如果 ComfyUI 服务器都无法连接，请检查云端实例')
    console.log('2. 如果 CUDA 状态服务无法连接，功能仍可用（自动切换备用方案）')
    console.log('3. 查看浏览器控制台的详细错误信息进行故障排除')
    console.log('\n🔗 相关服务地址:')
    console.log('- ComfyUI CUDA0: https://u680646-erl9-dd9fb7e3.westd.seetacloud.com:8443')
    console.log('- ComfyUI CUDA1: https://uu680646-erl9-dd9fb7e3.westd.seetacloud.com:8443')
    console.log('- CUDA 状态服务: http://8.155.53.4:6084')
  }
}

// 将诊断工具挂到全局 window 对象，方便在控制台调用
window.ComfyUIDiagnosis = ComfyUIDiagnosis

console.log('💡 诊断工具已加载，在控制台输入: ComfyUIDiagnosis.runFullDiagnosis() 运行完整诊断')

export default ComfyUIDiagnosis
